module.exports = __webpack_public_path__ + "img/picture_47.ed80fd75.png";